module.exports = __webpack_public_path__ + "TNM-Monogram-DarkNavy.svg?fbc7da00802cc720a46c79069794cbf3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/TNM-Monogram-DarkNavy.svg
// module id = 18
// module chunks = 0